import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import FilterSurvey from './FilterSurvey';
import ListSurvey from './ListSurvey';
import SurveyDetail from './SurveyDetail';
import i18next from 'i18next';

import AlertAlgo from '../controls/AlertSnack'
import Popup from '../controls/Popup'

import styles from '../../styles/survey.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    },
    divList: {
        marginTop: '50px'
    }
}));

export function Survey(props) {
    const classes = useStyles();

    const [listRef, setListRef] = useState(null);
    const [openPop, setOpenPop] = useState(false);
    const [titlePop, setTitlePop] = useState(false);
    const [surveyId, setSurveyId] = useState(0);
    const [statusList, setStatusList] = useState({ "O": true });
    const alertRef = useRef(null);

    useEffect(() => {
        handleTitle();
        resizeForm();
    }, []);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;

            const customHeight = height - titleBar - menu - offSet;

            const element = document.querySelector('#divSurvey');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    const handleFilter = (value) => {
        setStatusList(value);
        listRef.loadData(value);
    }

    const handleDetail = (id, description) => {
        setSurveyId(id);
        setTitlePop(description);
        setOpenPop(true);
    }

    const handleClosePop = () => {
        setOpenPop(false);
    }

    const reloadList = () => {
        listRef.loadData(statusList);
    }

    const handleTitle = () => {
        props.onLoadTitle(i18next.t('menu:survey'));
    }

    return (
        <div id="divSurvey" className={styles.rootBody} style={{zIndex: '-1'}}>
            <FilterSurvey handleFilter={handleFilter} />
            <div className={classes.divList}>
                <ListSurvey setListRef={(ref) => setListRef(ref)} handleDetail={handleDetail} />
            </div>
            <Popup title={titlePop} openPop={openPop} handleClosePop={handleClosePop}>
                <SurveyDetail surveyId={surveyId} reloadList={reloadList} />
            </Popup>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['survey', 'menu', 'error'], { wait: true })(Survey);